import { z } from 'zod';
import { recipientOfPaymentSchema } from './IRecipientOfPayment';
import { customerSchema } from './ICustomer';
import { progressPaymentSchema } from './IProgressPayment';
import { linkedInvoiceSchema } from './ILinkedInvoice';
import { invoiceMaterialPositionSchema } from './IInvoiceMaterialPosition';
import { invoicePartnerSchema } from './IInvoicePartner';
import { invoiceServicePositionSchema } from './IInvoiceServicePosition';
import { documentSchema } from './IDocument';

export const invoiceSchema = z.object({
    id: z.number().default(-1),
    invoice_number: z.string().default("132"),

    InvoiceState: z.number().default(10),
    InvoiceType: z.number().default(20),
    Project: z.number().default(-1),
    Customer: customerSchema.nullable().default(null),
    Document: documentSchema.nullable().default(null),
    
    LinkedInvoices: z.array(linkedInvoiceSchema).nullable().default([]),
    RecipientOfPayment: z.number().nullable().default(null),
    ReasonCancellation: progressPaymentSchema.nullable().default(null),
    ProgressPayment: progressPaymentSchema.nullable().default(null),

    paid_to: z.string().default(new Date().toISOString().split("T")[0]),
    paid_at: z.string().nullable().default(null),
    title: z.string().default("1. Abschlagsrechnung"),

    invoice_send_at: z.string().nullable().default(null),
    vat: z.number().default(0.19),
    total: z.number().default(0),
    cash_discount: z.number().nullable().default(null),



    InvoiceMaterialPositions: z.array(invoiceMaterialPositionSchema).default([]),
    InvoiceServicePositions: z.array(invoiceServicePositionSchema).default([]),
    InvoicePartners: z.array(invoicePartnerSchema).default([]),

    
})
export type IInvoice = z.infer<typeof invoiceSchema>;